import {
  BULK_DELETE,
  SEND_CONFIRMATION,
  USER_TYPE,
  USERS,
} from "constants/endpoints";
import { result } from "lodash";
import { deleteApi, get, patch, post, put } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes, alertVariants } from "constants/common";
import React from "react";

export const getUsers = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    per: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
  };
  try {
    const result = await get(
      `${USERS}?page=${params.page}&per=${params.per}&query=${params.search}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createUser = async (data, setErrors = () => {}) => {
  const payload = {
    ...data,
    user_type:
      data.user_type === "case_manager" ? "cs_manager" : data.user_type,
  };
  try {
    const result = await post(`${USERS}`, payload, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="User created successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    let errorMessage = "An error occurred";
    if (error?.response?.status === 422) {
      errorMessage = "Email has already been taken";
    } else if (error?.response?.statusText) {
      errorMessage = error.response.statusText;
    }
    toast(<CustomToast variant={alertTypes.DANGER} message={errorMessage} />);

    console.log(error);
  }
};

export const updateUser = async (data, id, setErrors = () => {}) => {
  try {
    const result = await put(`${USERS}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="User updated successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};

export const deleteBulkUser = async (data) => {
  try {
    const result = await put(`${USERS}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="User deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};

export const deleteUser = async (id) => {
  try {
    const result = await deleteApi(`${USERS}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="User deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "Failed to delete user"}
      />
    );
    console.log(error);
  }
};

export const getUserByType = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    per: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    user_type: obj?.user_type ? obj.user_type : "",
    order: obj.order ? obj.order : "asc",
    sort: obj.sort ? obj.sort : "full_name",
  };

  const finalSort =
    params.sort === "last_login" ? "last_login_at" : params.sort;

  try {
    const result = await get(
      `${USER_TYPE}/${params.user_type}?page=${params.page}&per=${params.per}&query=${params.search}&order=${params.order}&sort=${finalSort}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const sendUserConfirmationEmail = async (id) => {
  try {
    const result = await post(
      `${USERS}/${id}/${SEND_CONFIRMATION}`,
      null,
      true
    );
    toast(
      React.createElement(CustomToast, {
        variant: alertVariants.INFO,
        message: "User confirmation sent successfully",
      })
    );
    return result;
  } catch (error) {
    toast(
      React.createElement(CustomToast, {
        variant: alertVariants.DANGER,
        message: error?.response?.statusText,
      })
    );
    console.log(error);
  }
};
export const updateUserPassword = async (userId, password) => {
  try{
    const data = {
      user: {
        password
      },
    };

    const result = await put(`${USERS}/${userId}/password`, data, true);
    toast(
      React.createElement(CustomToast, {
        variant: alertVariants.INFO,
        message: "User password changed successfully",
      })
    );
    return result;
  } catch (error) {
    toast(
      React.createElement(CustomToast, {
        variant: alertVariants.DANGER,
        message: error?.response?.statusText,
      })
    );
    console.log(error);
  }
};
